import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Users, ArrowRight } from 'lucide-react';
import { RESULT_CONTENT, MetabolicType } from '../lib/constants';
interface ResultsPageProps {
  resultType: MetabolicType;
  onContinue: () => void;
}
export function ResultsPage({
  resultType,
  onContinue
}: ResultsPageProps) {
  const content = RESULT_CONTENT[resultType];
  useEffect(() => {
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'ViewContent', {
        content_name: 'Resultado Quiz Metabolico',
        content_category: 'Quiz',
        content_type: 'product'
      });
    }
  }, []);
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} exit={{
    opacity: 0
  }} className="flex flex-col items-center text-center px-4 py-6 min-h-[100dvh] bg-white max-w-md mx-auto shadow-xl overflow-y-auto hide-scrollbar" data-id="element-125">
      <div className="w-full max-w-[240px] mx-auto mb-6 relative" data-id="element-126">
        <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full -z-10" data-id="element-127" />
        <img src={content.image} alt={content.title} className="w-full max-h-[300px] object-contain rounded-3xl shadow-2xl" data-id="element-128" />
      </div>

      <h1 className="text-3xl font-extrabold text-dark mb-2" data-id="element-129">
        Tu metabolismo es:
      </h1>
      <h2 className="text-4xl font-black text-primary mb-6 uppercase tracking-wide" data-id="element-130">
        {content.title}
      </h2>

      <p className="text-lg text-gray-700 mb-6 px-2 leading-relaxed" data-id="element-131">
        {content.explanation}
      </p>

      <div className="bg-white rounded-2xl border border-gray-200 p-5 mb-6 w-full text-left shadow-sm" data-id="element-132">
        <h3 className="text-base font-bold text-dark mb-3" data-id="element-133">
          ¿Qué significa esto para ti?
        </h3>
        <ul className="space-y-2.5 text-sm text-gray-600" data-id="element-134">
          <li className="flex items-start gap-2" data-id="element-135">
            <span className="text-primary mt-0.5" data-id="element-136">✔</span> Tu cuerpo gestiona
            la energía de una forma específica.
          </li>
          <li className="flex items-start gap-2" data-id="element-137">
            <span className="text-primary mt-0.5" data-id="element-138">✔</span> Respondes mejor a un
            tipo de alimentación concreto.
          </li>
          <li className="flex items-start gap-2" data-id="element-139">
            <span className="text-primary mt-0.5" data-id="element-140">✔</span> El plan correcto
            puede ayudarte a optimizar tu metabolismo.
          </li>
        </ul>
      </div>

      <div className="bg-green-50 border border-green-100 rounded-2xl p-5 mb-8 w-full text-left" data-id="element-141">
        <p className="text-dark font-medium flex items-start gap-3" data-id="element-142">
          <span className="text-primary text-xl" data-id="element-143">💡</span>
          Cuando sigues el tipo de alimentación correcto, tu metabolismo puede
          funcionar de forma más eficiente.
        </p>
      </div>

      <div className="mt-auto w-full flex flex-col items-center gap-4" data-id="element-144">
        <div className="flex items-center gap-2 text-secondary text-sm font-medium" data-id="element-145">
          <Users className="w-4 h-4" data-id="element-146" />
          <span data-id="element-147">
            Más de 10,000 personas ya han usado este sistema metabólico.
          </span>
        </div>

        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={onContinue} className="w-full bg-primary text-white text-xl font-bold py-4 rounded-full shadow-lg shadow-primary/30 hover:bg-[#249e63] transition-colors flex items-center justify-center gap-2" data-id="element-148">
          Ver mi plan personalizado
          <ArrowRight className="w-6 h-6" data-id="element-149" />
        </motion.button>
      </div>
    </motion.div>;
}